import React from "react";
import { useI18n } from "@/i18n/I18nProvider";

function LegalSections({ data }) {
  return (
    <div className="border-t border-[hsl(var(--line))]">
      {data.sections.map((s, i) => (
        <div
          key={i}
          className="grid grid-cols-1 md:grid-cols-12 gap-8 py-10 md:py-14 border-b border-[hsl(var(--line))]"
        >
          <div className="md:col-span-4">
            <div className="stat-num text-[hsl(var(--ocre-deep))] text-2xl">
              {String(i + 1).padStart(2, "0")}
            </div>
            <h2 className="mt-3 text-2xl md:text-3xl" style={{ fontFamily: "'Playfair Display', serif" }}>
              {s.h}
            </h2>
          </div>
          <div className="md:col-span-7 md:col-start-6 text-[hsl(var(--ink-soft))] space-y-3 leading-relaxed">
            {s.lines.map((l, j) => (
              <p key={j}>{l}</p>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

export function LegalPage() {
  const { t } = useI18n();
  return (
    <div data-testid="page-legal" className="pt-20 md:pt-28 pb-24 container-x">
      <div className="eyebrow">— {t.legal.eyebrow}</div>
      <h1 className="mt-6 text-[clamp(2.5rem,6vw,5.5rem)] leading-[1.02] tracking-[-0.02em] max-w-4xl">
        {t.legal.title}
      </h1>
      <p className="mt-6 text-lg text-[hsl(var(--ink-soft))] max-w-2xl">{t.legal.lead}</p>
      <div className="mt-16">
        <LegalSections data={t.legal} />
      </div>
    </div>
  );
}

export function TermsPage() {
  const { t } = useI18n();
  return (
    <div data-testid="page-terms" className="pt-20 md:pt-28 pb-24 container-x">
      <div className="eyebrow">— {t.terms.eyebrow}</div>
      <h1 className="mt-6 text-[clamp(2.5rem,6vw,5.5rem)] leading-[1.02] tracking-[-0.02em] max-w-4xl">
        {t.terms.title}
      </h1>
      <p className="mt-6 text-lg text-[hsl(var(--ink-soft))] max-w-2xl">{t.terms.lead}</p>
      <div className="mt-16">
        <LegalSections data={t.terms} />
      </div>
    </div>
  );
}
